import type { GlobalStoreValues } from '@/store/useGlobalStore'

export const extractGlobalStoreLoggingData = (
  globalStore: GlobalStoreValues,
) => {
  const { user, app } = globalStore

  return {
    market: app?.alpha2 || undefined,
    user_id: user?.customer?.unicity || undefined,
    customer_type: user?.customerType || undefined,
    locale: app?.locale || undefined,
  }
}
